import RailsResource from './rails-resource';

class EnrollmentService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'enrollments',
      ajaxLoader: false
    });
  }

  findByActivity(activityId) {
    return this.call(`${this.url}/${this.resource}.json?activity_id=${activityId}`);
  }

  overviewStats(months = 6) {
    return this.call(`${this.url}/${this.resource}/overview-stats.json?last_x_month=${months}`);
  }

  actives() {
    return this.get(`${this.url}/${this.resource}.json?status=1&sort=name`);
  }

  discountPackages(enrollmentId) {
    return this.get(`${this.url}/${this.resource}/${enrollmentId}/discounts.json`);
  }

  updateBatchSchedules(enrollmentId, activityId, batchScheduleIds) {
    return this.patch(`${this.url}/${this.resource}/${enrollmentId}/batch-schedule.json`, true, {
      'batch_schedule_ids': batchScheduleIds,
      'activity_id': activityId
    });
  }
}

export default new EnrollmentService();
